import BaseService from '@/features/BaseService';

export default class CycleService extends BaseService {

  constructor() {
    super('cycles');
  }

}



// WEBPACK FOOTER //
// ./src/features/cycle/CycleService.js